import ExamRoomHeader from './ExamRoomHeader';

export default ExamRoomHeader;
